import $ from 'jquery';

export default class Modal {
  constructor() {
    this.$modal = $('.modal');
    this.$container = this.$modal.find('.modal__content');
    this.$overlay = $('.overlay');
    this.modifyDOM();
    this.addEvents();
  }

  modifyDOM() {
  }

  addEvents() {
    $(document).on('click', '.modal-open', this.toggleModal.bind(this));
    $(document).on('click', '.modal .btn--close-modal', this.closeModal.bind(this));
  }

  setTitle(title) {
    if (title) {
      this.$modal.find('.modal__header .h3').text(title);
    }
  }

  setContent(type, $toggle) {
    switch (type) {
      case 'youtube': {
        const url = this.youtubeParser($toggle.attr('href'));
        const $video = $('<iframe src="https://www.youtube.com/embed/' + url + '?autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>');
        $video.appendTo(this.$container);
        break;
      }
      case 'video': {
        const url = $toggle.attr('href');
        const $video = $('<video />');
        $video.attr('src', url);
        $video.attr('controls', true);
        $video.attr('autoplay', true);
        $video.appendTo(this.$container);
        break;
      }
      default:
        console.log('Modal type attribute missing or unsupported  (' + type + ')');
        break;
    }
  }

  youtubeParser(url) {
    const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
    const match = url.match(regExp);
    return (match && match[7].length === 11) ? match[7] : false;
  }

  closeModal(e) {
    if (typeof e !== 'undefined') {
      e.preventDefault();
    }
    this.$container.html('');
    this.$overlay.removeClass('active');
  }

  toggleModal(e) {
    if (typeof e !== 'undefined') {
      e.preventDefault();
    }
    let $toggle = $(e.target);

    if (!$toggle.hasClass('.modal-open')) {
      $toggle = $toggle.closest('.modal-open');
    }

    const title = $toggle.data('title');
    const type = $toggle.data('type');
    this.setTitle(title);
    this.setContent(type, $toggle);

    this.$overlay.toggleClass('active');
  }
}
